import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import './FormCheckbox.css';

const FormCheckbox = props => {
  const {
    name,
    children,
    initialValue,
    disabled
  } = props;
  
  const id = `form-checkbox--${props.name}`;
  const captionClassName = disabled
    ? 'form-checkbox__caption form-checkbox__caption--disabled'
    : 'form-checkbox__caption';
  return (
    <label htmlFor={id} className="form-checkbox">
      <Field 
        name={name}
        component="input"
        type="checkbox"
        className="form-checkbox__styled"
        initialValue={initialValue}
      />
        <span className={captionClassName}>{children}</span>
    </label>
  );
}

FormCheckbox.propTypes = {
  children: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.bool
};

FormCheckbox.defaultProps = {
  disabled: false,
  children: '',
  required: false,
  value: true
};

export default FormCheckbox;



// WEBPACK FOOTER //
// ./src/components/form/FormCheckbox.js